import './microphone.styl';

import React from 'react';
import Icon from '../icon/Icon';
import VoiceRecognition from './VoiceRecognition';

import classNames from 'classnames';

export default class Microphone extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false
    };
  }

  toggleMicrophone() {
    this.setState({active: !this.state.active});
  }

  onRecognized({interimTranscript, finalTranscript}) {

    // console.log(interimTranscript);
    // console.log(finalTranscript);
    this.setState({active: false}, () => this.props.onRecognized(finalTranscript));
  }

  render() {
    const {active} = this.state;

    if (typeof window === 'undefined'
      || !(window.webkitSpeechRecognition
      || window.mozSpeechRecognition
      || window.msSpeechRecognition
      || window.oSpeechRecognition)
    ) {
      return null;
    }

    return (
      <div
        className={classNames({
          microphone: true,
          microphone_active: active
        })}
      >
        {active &&
          <VoiceRecognition
            onEnd={console.log}
            onError={console.log}
            onResult={::this.onRecognized}
          />
        }
        <div className="microphone__handler" onClick={() => this.toggleMicrophone()}>
          <Icon name="microphone" />
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/client/components/microphone/Microphone.js